export const isSelfServeClient = auth => auth?.type >= 5 && auth?.type < 8;
